export const SESSION_SYNC_CHANNEL = "compcheck-session-sync";
export const LOGOUT_STORAGE_KEY = "compcheck_logout";
export const LOGOUT_EVENT = "logout";

export const broadcastLogout = () => {
  try {
    localStorage.setItem(LOGOUT_STORAGE_KEY, Date.now().toString());
  } catch {
    // ignore storage failures
  }

  try {
    const channel = new BroadcastChannel(SESSION_SYNC_CHANNEL);
    channel.postMessage({ type: LOGOUT_EVENT });
    channel.close();
  } catch {
    // BroadcastChannel may be unavailable
  }
};

export const subscribeSessionSync = (onLogout) => {
  const handleStorage = (event) => {
    if (event.key === LOGOUT_STORAGE_KEY) {
      onLogout();
    }
  };

  window.addEventListener("storage", handleStorage);

  let channel;
  try {
    channel = new BroadcastChannel(SESSION_SYNC_CHANNEL);
    channel.onmessage = (message) => {
      if (message?.data?.type === LOGOUT_EVENT) {
        onLogout();
      }
    };
  } catch {
    // BroadcastChannel may be unavailable
  }

  return () => {
    window.removeEventListener("storage", handleStorage);
    channel?.close();
  };
};
